import React, {useState} from 'react';
import Select from "react-select";
import {
    bbDictionaryOfCustomHomePages,
    bbDoesCustomerHaveAccessToSubscription,
    bbFindUserTagsByTagId,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {addCustomHomePageTag, setInitUrl, updateCustomHomePageTag} from "../../../actions";

const CustomHomePageSelect = () => {

    const authUser = useSelector(({auth}) => auth.authUser);
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const customer = customers ? customerInView ? customers[customerInView] : null : null;
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);
    const dispatch = useDispatch();
    const isAdmin = isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");


    const isDisabled = false;
    const textColor = isDisabled ? "text-light-gray" : "";
    const customHomePageTags = bbFindUserTagsByTagId(authUser, 52);
    // console.log("Customer has the following customHomePageTags", customHomePageTags);

    // const isBRPortfolioCustomer = true;
    const isBRPortfolioCustomer = bbDoesCustomerHaveAccessToSubscription(customer, 1);
    const isBRBusinessCustomer = bbDoesCustomerHaveAccessToSubscription(customer, 2);
    const hasCIRT = bbDoesCustomerHaveAccessToSubscription(customer, 0);

    let options;
    const customHomePageOptionArray = Object.values(bbDictionaryOfCustomHomePages);
    const defaultOption = customHomePageOptionArray.slice(0, 1);
    const optionsBRBusiness = customHomePageOptionArray.slice(4, 8);
    const optionsBRPortfolio = customHomePageOptionArray.slice(8, 12);
    const optionsCIRT = customHomePageOptionArray.slice(1, 4);
    const optionsAdmin = customHomePageOptionArray.slice(12, 17)


    if(isAdmin || isStaff){
        options= customHomePageOptionArray;
    } else if(isBRBusinessCustomer && isBRPortfolioCustomer && hasCIRT){
        options = defaultOption
            .concat(optionsBRBusiness, optionsBRPortfolio, optionsCIRT);
    } else if(isBRBusinessCustomer && isBRPortfolioCustomer && !hasCIRT){
        options = defaultOption
            .concat(optionsBRBusiness, optionsBRPortfolio);
    } else if(isBRBusinessCustomer && !isBRPortfolioCustomer && hasCIRT){
        options = defaultOption
            .concat(optionsBRBusiness, optionsCIRT);
    } else if(isBRBusinessCustomer && !isBRPortfolioCustomer && !hasCIRT){
        options = defaultOption
            .concat(optionsBRBusiness,);
    } else if(!isBRBusinessCustomer && isBRPortfolioCustomer && hasCIRT){
        options= defaultOption
            .concat(optionsBRPortfolio,optionsCIRT);
    } else if(!isBRBusinessCustomer && isBRPortfolioCustomer && !hasCIRT){
        options = defaultOption
            .concat(optionsBRPortfolio,);
    } else if(!isBRBusinessCustomer && !isBRPortfolioCustomer && hasCIRT){
        options = defaultOption
            .concat(optionsCIRT,);
    } else {
        options = [];
    }

    // const [homePage, setHomePage] = useState(customHomePageTags && customHomePageTags.length > 0
    //                                                 ? customHomePageTags[0].definition.description : options[0])

    const [homePage, setHomePage] = useState(customHomePageTags && customHomePageTags.length > 0
                                                ? bbDictionaryOfCustomHomePages[`${customHomePageTags[0].details}`]
                                                : null);

    // console.log("home page is set to", homePage);
    const hasTags = customHomePageTags && customHomePageTags.length > 0;

    // hasTags && console.log("this is customHome Page Tags", customHomePageTags)

    const handleOnClick = (value) =>{
        // console.log("this is value", value, value.id)
        setHomePage(value)

        if(hasTags && customHomePageTags[0].details && value.id !== 0){
            // console.log("udpateing and aadding new tag")
            dispatch(updateCustomHomePageTag(customHomePageTags[0]))
            dispatch(addCustomHomePageTag(authUser.user.id, value.id, false))
        } else if(hasTags && value.id === 0){
            // console.log("deactiving current tag")
            dispatch(updateCustomHomePageTag(customHomePageTags[0]))
        } else{
            // console.log("adding new tag")
            dispatch(addCustomHomePageTag(authUser.user.id, value.id, true))
        }



    }

    console.log("CustomHomePageSelect options", options);

    return(
        <div className={`row align-self-center ${textColor}`}>
            <Tooltip title={"Set the homepage for when you login."}>
                <>
                    <p className={"col-5 text-right align-self-center"}>Custom Home Page:</p>
                    <p className={"col-1"}> </p>
                    <p className={"col-5 text-left"}>
                        <Select
                            className={"col-6 m-0 p-0"}
                            options={options}
                            value={homePage}
                            onChange={(value) =>handleOnClick(value)}>
                        </Select>
                    </p>
                </>
            </Tooltip>
            {isDisabled && <ComingSoonIconSettings className={"align-self-center mt-1 pt-1"}/>}
        </div>


    )
}

export default CustomHomePageSelect;